import * as R from 'ramda'

const transformCategories = R.compose(R.map(Number), R.split(','))

export const normalizeNewsPayload = R.evolve({
  category: transformCategories,
})
